import type { PetSpeciesID } from 'src/replicant/pet';
import type { DialogVersion } from 'src/replicant/conversation/conversation.analytics';

export const NEW_PET_DIALOG_SPECIES = [
  'ball',
  'starball',
  'crab',
  'hamster',
  'squirrel',
  'turtle',
  'fish',
] as const satisfies readonly PetSpeciesID[];

const newPetDialogSpecies: ReadonlySet<PetSpeciesID> = new Set(
  NEW_PET_DIALOG_SPECIES,
);

/**
 * Paths and content version for a species' selected conversation assets.
 */
type PetConversationAssetPaths = {
  dialogs: string;
  scripts: string;
  version: DialogVersion;
};

/**
 * Returns the conversation asset paths for a species and A/B bucket.
 * Species without expanded content always use the production assets.
 *
 * @param species Pet species whose conversation assets should be selected.
 * @param useNewPetDialogs Whether the player is in the expanded-dialog bucket.
 * @returns Selected dialog and script paths with their content version.
 */
export function getPetConversationAssetPaths(
  species: PetSpeciesID,
  useNewPetDialogs: boolean,
): PetConversationAssetPaths {
  // Expanded-dialog species use v2 assets only for enabled players.
  const version: DialogVersion =
    useNewPetDialogs && newPetDialogSpecies.has(species) ? 'v2' : 'v1';
  const versionSuffix = version === 'v2' ? '_v2' : '';
  const basePath = `assets/species/${species}`;

  // Return the paths and the matching version used by analytics.
  return {
    dialogs: `${basePath}/Dialogs${versionSuffix}.json`,
    scripts: `${basePath}/Scripts${versionSuffix}.json`,
    version,
  };
}
